import * as React from 'react';
import { Events } from 'core/infrastructure';

abstract class BaseComponent<P, S> extends React.Component<P, S> {

	protected mounted = false;
	private eventsDeregistrationFunctions: ((...args: any[]) => any)[] = [];

	constructor(props: P) {
		super(props);

		this.state = this.createInitialState(props) as S;
		this.setState = this.setState.bind(this);
	}

	abstract createInitialState(props: P): Nullable<S>;

	// Obligo a redefinirlos con la esperanza de que así no
	// machaquemos el componentWillUnmoun/DidMount del padre
	abstract onComponentDidMount(): void;
	abstract onComponentWillUnmount(): void;

	componentDidMount() {
		this.mounted = true;
		this.onComponentDidMount();
	}

	componentWillUnmount() {
		this.mounted = false;
		this.eventsDeregistrationFunctions.forEach(fn => fn());
		this.eventsDeregistrationFunctions = [];
		this.onComponentWillUnmount();
	}

	// Métodos varios para asegurar que no se interactúa con el componente después de
	// desmontarlo. Útiles cuando tienes promesas volando por el infinito.

	setState<K extends keyof S>(funcOrState: ((prevState: S, props: P) => Pick<S, K>) | Pick<S, K>, callback?: () => any): void {
		if (!this.mounted) {
			// Siempre invoco la callback para permitir desregistros de eventos o cosas similares
			// como la resolución de promesas
			callback?.();
			return;
		}

		// Podría hacer un if typeof funcOrState == 'function' y llamar tanto en el
		// if como en el else a super.setState(funcOrState) para que typescript
		// se quede contento, pero parece una estupidez hacerlo así
		super.setState(funcOrState as any, callback);
	}

	ifMounted(callback: () => any) {
		if (this.mounted)
			callback();
	}

	on<P extends Events.NotVoidEvents>(event: P, listener: Events.EventListener<P>): void;
	on<P extends Events.VoidEvents>(event: P, listener: () => Promise<void>): void;
	on(type: any, listener: Events.EventListener<any>) {
		this.eventsDeregistrationFunctions.push(Events.on(type, listener));
	}

}

export default BaseComponent;
